import Button from "../../components/atoms/Button";
import ProductList from "../../components/organisms/ProductList";
import FlexSection from "../../components/organisms/FlexSection";

const components = {
  Button: Button,
  ProductList: ProductList,
  FlexSection: FlexSection,
};

export default components;
